// extracted by mini-css-extract-plugin
export var disabled = "_rv-0";